const isProd = () => import.meta.env.SYSTEM_APP_MODE === "production";

export default isProd;